import axiosConfig from './axiosConfig';
// import { reactLocalStorage } from 'reactjs-localstorage';
import { removeUserSession } from './../Utils/Common';

import { SIGN_IN_URL, UNAUTHORISED_CODE, UNAUTHORISED_CODE_401 } from './../Utils/appConstants';
import { getToken, getPayUToken } from "./Common";
// import { useHistory } from "react-router-dom";
// const history = useHistory();
import axios from 'axios';
// function redirectLogin() {
//   if (typeof window !== 'undefined') {
//     window.location.href = "/login";
//   }
// }


/**
 * POST request with FormData (for file uploads)
 * Uses axiosConfig with proper headers for multipart/form-data
 * @param {string} url - API endpoint
 * @param {FormData} payload - FormData object
 * @param {object} history - React Router history
 * @returns {Promise}
 */
export const postFormDataRequest = (url, payload, history) => {
  // Try getToken() first, fallback to localStorage
  let token = getToken();
  if (!token) {
    token = localStorage.getItem('token') || localStorage.getItem('x-access-token') || '';
  }
  const PayUToken = getPayUToken();
  return new Promise((resolve, reject) => {
    return axiosConfig.post(url, payload, {
      headers: {
        'x-access-token': token,
        'payu-access-token': PayUToken,
        // Do NOT set Content-Type; browser will set with boundary
      },
    })
    .then((response) => {
      if (response && response.data) {
        return resolve(response.data);
      } else {
        return reject(response.data);
      }
    })
    .catch(function (error) {
      if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
        removeUserSession();
        history.push(SIGN_IN_URL);
      } else {
        return resolve(error && error.response && error.response.data);
      }
    });
  });
};

export const getNewRequest = (url, data, history) => {
  const token = getToken()
  const PayUToken = getPayUToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.get(url, { params: data, headers: { 'x-access-token': token, 'payu-access-token': PayUToken } })
      .then((response) => {
        if (response) {
          // console.log("state-----",response)
          return resolve(response.data)
        } else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        // console.log("err.response.statuscode-----", error.response.status);
        if (error.response && error.response.status && error.response.status.toString() === ((UNAUTHORISED_CODE || UNAUTHORISED_CODE_401))) {
          removeUserSession();
          history.push(SIGN_IN_URL);
        } else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};


/**
 * Download a file (GET request with blob response)
 * Uses axiosConfig (which has the base URL configured)
 * @param {string} url - API endpoint (relative path, e.g., '/fund-transfer/export-a2a-dft')
 * @param {object} history - React Router history (for redirect on 401)
 * @param {object} options - additional axios config (e.g., headers, params)
 * @returns {Promise<object>} - Returns the full axios response object with blob in .data
 */
export const downloadRequest = (url, history, options = {}) => {
    const token = getToken();
    const PayUToken = getPayUToken();
    return new Promise((resolve, reject) => {
        return axiosConfig.get(url, {
            headers: {
                'x-access-token': token,
                'payu-access-token': PayUToken,
                ...options.headers,
            },
            responseType: 'blob', // Important: get blob
            ...options,
        })
        .then((response) => {
            // response is the full axios response object with blob in .data
            resolve(response);
        })
        .catch(function (error) {
            if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
                removeUserSession();
                history.push(SIGN_IN_URL);
            } else {
                // Try to read error from blob if available
                if (error.response && error.response.data) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const errorJson = JSON.parse(reader.result);
                            reject(new Error(errorJson.message || errorJson.error || 'Download failed'));
                        } catch {
                            reject(new Error('Download failed'));
                        }
                    };
                    reader.readAsText(error.response.data);
                } else {
                    reject(error);
                }
            }
        });
    });
};

export const postPayURequest = (url, payload, history) => {
  const token = getToken()
  const PayUToken = getPayUToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.post(url, payload, { headers: { 'x-access-token': token, 'payu-access-token': PayUToken } })
      .then((response) => {
        // console.log("response.data ===========",response.data)
        // if (response && response.data && response.data.code === API_SUCCESS_CODE) {
        if (response && response.data) {
          return resolve(response.data)
        } else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        // console.log("error ===========",error.response)
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          history.push(SIGN_IN_URL);
        } else {
          return resolve(error && error.response && error.response.data)
        }
      });
  });
};

export const getRequest = (url, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.get(url, { headers: { 'x-access-token': token } })
      .then((response) => {
        if (response) {
          // console.log("state-----",response)
          return resolve(response.data)
        }
        else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          // console.log("error.response.status--11----", error.response.status)
          removeUserSession();
          history.push(SIGN_IN_URL);
        } else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};

export const getRequestNewApi = (url, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.get(url, { headers: { 'x-access-token': token } })
      .then((response) => {
        return resolve(response.data)
      })
      .catch(function (error) {
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          history.push(SIGN_IN_URL);
        } else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};

export const deleteRequestNewApi = (url, payload, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    let config = {}
    if (payload) {
      config.data = payload
    }
    config.headers = { 'x-access-token': token }
    // console.log("config 11------", config)
    return axiosConfig.delete(url, config)
      .then((response) => {
        // console.log("response 11------", response)
        if (response) {
          return resolve(response.data)
        } else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          removeUserSession();
          history.push(SIGN_IN_URL);
        } else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};

export const awsGetRequest = (url) => {
  return new Promise((resolve, reject) => {
    return axiosConfig.get(url)
      .then((response) => {
        return resolve(response.data)
      })
      .catch(function (error) {
        return reject(error)
      });
  })
};


export const postRequest = (url, payload, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.post(url, payload, { headers: { 'x-access-token': token } })
      .then((response) => {
        // if (response && response.data && response.data.code === API_SUCCESS_CODE) {
        // console.log("response ===========",response.data)
        if (response && response.data) {
          return resolve(response.data)
        } else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        // console.log("error ===========",error.response)
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          removeUserSession();
          history.push(SIGN_IN_URL);
        }
        else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};


export const postNewApiRequest = (url, payload, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axios.post(url, payload, { headers: { 'x-access-token': token,'appKey': "srpay" } })
      .then((response) => {
        if (response && response.data) {
          return resolve(response.data)
        } else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        // console.log("error ===========",error.response)
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          removeUserSession();
          history.push(SIGN_IN_URL);
        }
        else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};


export const getNewApiRequest = (url, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axios.get(url, { headers: { 'x-access-token': token,'appKey': "srpay" } })
      .then((response) => {
        if (response && response.data) {
          return resolve(response.data)
        } else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        // console.log("error ===========",error.response)
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          removeUserSession();
          history.push(SIGN_IN_URL);
        }
        else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};



export const postDownloadRequest = (url, payload, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.post(url, payload, { responseType: "arraybuffer", headers: { 'x-access-token': token, "Content-Type": "application/zip", "Accept": "application/zip" } })
      .then((response) => {
        // if (response && response.data && response.data.code === API_SUCCESS_CODE) {
        // console.log("response ===========",response.data)
        if (response && response.data) {
          return resolve(response.data)
        } else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        // console.log("error ===========",error.response)
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          removeUserSession();
          history.push(SIGN_IN_URL);
        }
        else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};

export const postRequestNewApi = (url, payload, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.post(url, payload, { headers: { 'x-access-token': token } })
      .then((response) => {
        return resolve(response.data)
      })
      .catch(function (error) {
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          history.push(SIGN_IN_URL);
        }
        else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};

export const postRequestWithoutHistory = (url, payload) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.post(url, payload, { headers: { 'x-access-token': token } })
      .then((response) => {
        if (response && response.data) {
          return resolve(response.data)
        }
        else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        return reject(error)
      });
  })
};

export const putRequest = (url, payload, history) => {
  const token = getToken()
  // console.log("payload -------",payload)
  return new Promise((resolve, reject) => {
    return axiosConfig.put(url, payload, { headers: { 'x-access-token': token } })
      .then((response) => {
        if (response && response.data) {
          return resolve(response.data)
        }
        else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          history.push(SIGN_IN_URL);
        } else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};

export const deleteRequest = (url, history) => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    return axiosConfig.delete(url, { headers: { 'x-access-token': token } })
      .then((response) => {
        if (response && response.data) {
          return resolve(response.data)
        } else {
          return reject(response.data)
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status && (error.response.status.toString() === UNAUTHORISED_CODE || error.response.status.toString() === UNAUTHORISED_CODE_401)) {
          removeUserSession();
          history.push(SIGN_IN_URL);
        } else {
          return resolve(error && error.response && error.response.data)
        }
      });
  })
};